const nodeEnv = process.env.NODE_ENV;

export const CDNLOGOLINK =
  nodeEnv === 'production'
    ? 'https://cdn.bouqs.com/storefront-ui/logo-green.svg'
    : 'https://cdn.staging.bouqs.com/storefront-ui/logo-green.svg';
